import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20corporate%20background%20with%20soft%20amber%20and%20cream%20gradient%2C%20flowing%20organic%20waves%20and%20gentle%20geometric%20shapes%2C%20professional%20yet%20inviting%20atmosphere%2C%20minimalist%20design%2C%20light%20airy%20feel%2C%20subtle%20golden%20highlights%2C%20modern%20Japanese%20corporate%20aesthetic%2C%20no%20text&width=1800&height=800&seq=dream-cta-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/85 to-foreground-900/70" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          まずはお気軽にご相談ください
        </h2>
        <p className="text-white/70 text-sm md:text-base mb-8 leading-relaxed max-w-xl mx-auto">
          御社の課題やご要望をお聞かせください。最適なソリューションをご提案いたします。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/contact"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold rounded-md whitespace-nowrap cursor-pointer transition-all duration-200 bg-primary-500 text-background-50 hover:bg-primary-600 hover:scale-105"
          >
            お問い合わせはこちら
          </Link>
          <Link
            to="/privacy"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-medium rounded-md whitespace-nowrap cursor-pointer transition-all duration-200 border border-white/30 text-white hover:bg-white/10 hover:border-white/50"
          >
            プライバシーポリシー
          </Link>
        </div>
      </div>
    </section>
  );
}
